import { Trans, useTranslation } from 'react-i18next';

import errorImage from '@/assets/error.png';
import { defaultModalStyles } from '@/components/Elements/Modal/customStyles';
import { getMyRateURL } from '@/utils/helpers';

import { PaymentsModal } from '../PaymentsModal';

export type ErrorModalProps = {
  status: number;
  detail?: string;
  onRequestClose: () => void;
};
const INVOICE_DETAIL = 'There are pending invoices for this customer';
const CANCELLED_ANNUAL_PRODUCT_REACTIVATION_DETAIL =
  'Reactivation is not available for canceled annual products.';
const TRANSLATION_KEYS = {
  402: 'ErrorModal.error',
  409: 'ErrorModal.errorPending',
  500: 'ErrorModal.errorSupport',
  503: 'ErrorModal.error',
};

export const ErrorModal = ({ status = 0, detail = '', onRequestClose }: ErrorModalProps) => {
  const { t } = useTranslation();
  const isOpen: boolean = status > 0;

  const getLabelError = (status: number, detail?: string): string => {
    if (status == 409 && detail == INVOICE_DETAIL) return t('ErrorModal.errorInvoice');
    if (status == 409 && detail == CANCELLED_ANNUAL_PRODUCT_REACTIVATION_DETAIL)
      return t('ErrorModal.errorReactivation');

    const labelError: string =
      typeof TRANSLATION_KEYS[status as keyof typeof TRANSLATION_KEYS] === 'undefined'
        ? 'ErrorModal.errorSupport'
        : TRANSLATION_KEYS[status as keyof typeof TRANSLATION_KEYS];
    return t(labelError).replace('{{rateURL}}', getMyRateURL());
  };

  const onDefaultRequestClose = () => {
    onRequestClose();
  };
  return (
    <PaymentsModal
      isOpen={isOpen}
      closeButton={true}
      style={defaultModalStyles}
      onRequestClose={onDefaultRequestClose}
    >
      <img
        width="100"
        src={errorImage}
        alt={t('SecurityModal.savedSuccess')}
        className="mb-8 m-auto"
      />
      <h3 className="md__payments__modal--h3">
        <Trans
          components={
            // eslint-disable-next-line
            { a: <a /> }
          }
        >
          {getLabelError(status, detail)}
        </Trans>
      </h3>
    </PaymentsModal>
  );
};
